module.exports = __webpack_public_path__ + "static/grad-6f429050580f2ccffb422099a3f4fb0a.jpg";